import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";
import Faq from "./Faq";
import FormModal from "../../widgets/FormModal";


function Research() {

    const [show, setShow] = useState(false);
    const openIframeWindow = () => {
        setShow(!show);
    }
    return (
        <>  <section className="light_bg">
            <Header />
            <div className="top_space"></div>

            <section className="ps">
                <div className="container">
                    <div className="position-relative research_man_banner">
                        <img src="/assets/img/research_man_banner.webp" alt="research" className="research_banner" />
                        <div className="row position-relative">
                            <div className="col-md-5">
                                <p className="text-transform-capitalize">Our research team is continuously finding out correlations between various genetic factors and metabolic factors and hence our accuracy levels in predicting the Triggers for diseases are incomparable.</p>
                                <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
                            </div>
                        </div>
                    </div>
                </div>



            </section>


            <section className=" ps  ">
                <div className="container  ">


                    <div className="row">
                        <div className="col-md-5">
                            <h2 className="hadding mb-3">Research</h2>
                        </div>
                        <div className="col-md-7">
                            <div className="research_box1 text-end">
                                <div className="text-start d-flex gap-4">
                                    <img src="/assets/img/r1.webp" alt="fit test" />
                                    <h4>Genetic Link Between Magnesium Deficiency, Depression, and Stress Resilience</h4>
                                </div>
                                <Link to="/research/genetic-link" >Read More</Link>
                                {/* <a href="#">Read More</a> */}
                            </div>
                            <div className="research_box1 text-end">
                                <div className="text-start d-flex gap-4">
                                    <img src="/assets/img/r2.webp" alt="fit test" />
                                    <h4>Study Reveals 99.6% of Individuals with Low Stress Resilience Genes Have a High Genetic Risk for Depression</h4>
                                </div>
                                <Link to="/research/study-reveals" >Read More</Link>
                            </div>
                            <div className="research_box1 text-end">
                                <div className="text-start d-flex gap-4">
                                    <img src="/assets/img/r3.webp" alt="fit test" />
                                    <h4>Genetic Risk Study: Depression, Diabetes, and Obesity in the Indian Population</h4>
                                </div>
                                <Link to="/research/genetic-risk" >Read More</Link>
                            </div>
                            <div className="research_box1 text-end">
                                <div className="text-start d-flex gap-4">
                                    <img src="/assets/img/r4.webp" alt="fit test" />
                                    <h4>EPLIMO Genetic Research: Uncovering Cardiac and Fitness Risks in the Indian Population</h4>
                                </div>
                                <Link to="/research/genetic-research" >Read More</Link>
                            </div>

                            <div className="research_box1 text-end">
                                <div className="text-start d-flex gap-4">
                                    <img src="/assets/img/r5.webp" alt="fit test" />
                                    <h4>Study Reveals Running Marathons or Doing Endurance Exercises Are Not Indications of Good Heart Health</h4>
                                </div>
                                <Link to="/research/study-reveals-running" >Read More</Link>
                            </div>
                            <div className="research_box1 text-end">
                                <div className="text-start d-flex gap-4">
                                    <img src="/assets/img/r6.webp" alt="fit test" />
                                    <h4>Study Reveals Correlation Between Heart Failure, Prolonged QT, and Magnesium Deficiency</h4>
                                </div>
                                <Link to="/research/study-reveals-correlation" >Read More</Link>
                            </div>
                            <div className="research_box1 text-end">
                                <div className="text-start d-flex gap-4">
                                    <img src="/assets/img/r7.webp" alt="fit test" />
                                    <h4>Study Reveals Genetic Risk of Coronary Artery Disease Linked to Impaired DNA Repair and Antioxidant Intake Rather Than Elevated LDL</h4>
                                </div>
                                <Link to="/research/study-reveals-genetic" >Read More</Link>
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            <Faq />



            <section className="you_ready_sec  position-relative  overflow-hidden">
                <img src="/assets/img/plan/you-ready-bg.webp" alt="cour raddy" className="cour_raddy mo_none" />
                <img src="/assets/img/plan/you-ready-bg2.webp" alt="cour raddy" className="cour_raddy pc_none" />

                <div className="container position-relative">
                    <div className="row position-relative">
                        <div className="col-md-5  ">
                            <h2 className="hadding mb-4    ">Are You Ready to Take Control of Your Future Health?</h2>
                            <p className=" mb-md-4 mb-3 ">EPLIMO is more than a health check.  It’s a blueprint for living stronger, longer, and happier. Don’t wait for symptoms to become problems. Take charge today and start living at your peak.</p>
                            <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
                        </div>
                    </div>
                </div>
                 <FormModal show={show} setShow={setShow} />
            </section>

            <Footer /> </section>
        </>
    );
}

export default Research;
